
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"48","height":"48","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M37.35 17.398a3.436 3.436 0 00-2.42-2.426c-2.132-.572-10.69-.572-10.69-.572s-8.552 0-10.69.572a3.436 3.436 0 00-2.42 2.426c-.57 2.138-.57 6.602-.57 6.602s0 4.464.57 6.602a3.436 3.436 0 002.42 2.427c2.138.571 10.69.571 10.69.571s8.558 0 10.69-.572a3.436 3.436 0 002.42-2.426c.57-2.138.57-6.602.57-6.602s0-4.464-.57-6.602z","fill":"#fff"}}),_c('path',{attrs:{"d":"M21.507 28.115L28.615 24l-7.108-4.115v8.23z","fill":"#fff"}})])
          )
        }
      }
    